import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { DataTableModule, SharedModule } from 'primeng/primeng';

import { BankStatementsBatchComponent } from './bank-statements-batch.component';
import { EntityFinanceModule } from '../../entities/finance/entity-finance.module';
import { CreateAccountDialogComponent } from './create-account-dialog/create-account-dialog.component';
import { FindAccountDialogComponent } from './find-account-dialog/find-account-dialog.component';
import { TimelineMonthDetailsDialogComponent } from './timeline-month-details-dialog/timeline-month-details-dialog.component';
import { DuplicatesInvestigationDialogComponent } from './duplicates-investigation-dialog/duplicates-investigation-dialog.component';
import { SharedModule as AppSharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule.forRoot(),
    DataTableModule,
    SharedModule,
    AppSharedModule,
    EntityFinanceModule
  ],
  declarations: [
    BankStatementsBatchComponent,
    CreateAccountDialogComponent,
    FindAccountDialogComponent,
    TimelineMonthDetailsDialogComponent,
    DuplicatesInvestigationDialogComponent
  ],
  exports: [
    BankStatementsBatchComponent
  ],
  entryComponents: [
    CreateAccountDialogComponent,
    FindAccountDialogComponent,
    TimelineMonthDetailsDialogComponent,
    DuplicatesInvestigationDialogComponent
  ]
})
export class BankStatementsBatchModule { }



// WEBPACK FOOTER //
// ./src/app/finance/bank-statements-batch/bank-statements-batch.module.ts